import React, { useEffect, useState } from "react";
import { View, Text, TouchableOpacity, Modal, Image } from "react-native";
import { AppColors } from "../../../../utility/AppColors";
import { AppFontStyle } from "../../../../styles/AppFontStyle";
import { AppImages } from "../../../../utility/AppImages";
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  useDeviceSize,
} from "rn-responsive-styles";
import Separator from "../../../../Components/Separator";
import { useNavigation } from "@react-navigation/native";
import { toast } from "react-toastify";
import { navigateToScreen } from "../../../../utility/NavigationHelper";
import { AppScreens } from "../../../Utility/AppScreens";
import { ShowLoader } from "../../../../common/ShowLoader";
import useAdminStatus from "../../../../utility/hooks/useAdminStatus";
import Avatar from "../../../../Components/choose-avatar-components/Avatar";
import { clearAllCaches } from "../../../../utility/cacheManager";
import { logoutUser } from "../../../../services/authAPI";
import { useUserData } from "../../../../context/UserDataContext";

const ProfilePopup = ({
  isVisible,
  onClose,
  position,
  accessToken,
  userProfileData,
  setReferAndEarnPopUp,
}: {
  isVisible: boolean;
  onClose: () => void;
  position: { x: number; y: number; width: number; height: number };
  accessToken: string;
  userProfileData: any;
  setReferAndEarnPopUp: (show: boolean) => void;
}) => {
  if (!isVisible) return null;
  const deviceSize = useDeviceSize();
  const styles = useStyles();
  const navigation = useNavigation();
  const [showLoader, setShowLoader] = useState(false);
  const isAdmin = useAdminStatus();
  const { clearUserData } = useUserData();

  const logout = async () => {
    try {
      setShowLoader(true);
      onClose(); // Close the popup immediately

      const params = { accessToken: accessToken };

      // Call logout API without waiting (fire and forget)
      logoutUser(params).then((response) => {
        if (response.statusCode === 200) {
          console.log("Logout API success:", response.body?.message);
        } else {
          console.warn("Logout API warning:", response);
        }
      }).catch((apiError) => {
        console.error("Logout API error:", apiError);
      });

      // Always clear all caches - user should be logged out locally regardless of API response
      await clearAllCaches();

      // Set a flag in sessionStorage to show toast after redirect
      sessionStorage.setItem('showLogoutSuccessToast', 'true');

      // Force a full page reload to ensure all React state is cleared
      // This will restart the app and AuthContext will handle navigation
      window.location.href = window.location.origin + '/login';

    } catch (error) {
      console.error("Logout error:", error);
      setShowLoader(false);
      // Set flag for error message
      sessionStorage.setItem('showLogoutErrorToast', 'true');
      // Even if there's an error, force a reload to clear all state
      window.location.href = window.location.origin + '/login';
    }
  };

  return (
    <Modal transparent={true} visible={isVisible} onRequestClose={onClose}>
      <View style={styles.modalOverlay}>
        <TouchableOpacity style={styles.overlayBackground} onPress={onClose} />
        <View
          style={[
            styles.modalContent,
            {
              position: "absolute",
              top: position.y + 10,
              ...(deviceSize === DEVICE_SIZES.XS ||
              deviceSize === DEVICE_SIZES.SM
                ? {}
                : { right: 10 }),
              width:
                deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                  ? "100%"
                  : 281,
            },
          ]}
        >
          <TouchableOpacity
            style={{
              justifyContent: "center",
              alignItems: "center",
            }}
            onPress={() => {
              onClose();
            }}
          >
            <Image
              source={AppImages.icCloseWhiteSvg}
              style={{
                height: 20,
                width: 20,
                position: "absolute",
                right: -15,
                top: -15,
              }}
            />
          </TouchableOpacity>
          <View style={{ alignItems: "center" }}>
            <View
              style={{
                borderRadius: 80,
                backgroundColor: AppColors.lightPurple_604e74,
                overflow: "hidden",
              }}
            >
              <Avatar
                src={userProfileData?.profilePicture}
                variant="profileMedium"
              />
            </View>
            <Text
              style={[
                AppFontStyle.BOLD_ANYBODY_18,
                {
                  paddingVertical: 10,
                },
              ]}
            >
              {userProfileData?.userID}
            </Text>

            <TouchableOpacity
              onPress={() => {
                onClose();
                navigateToScreen(navigation, AppScreens.Profile);
              }}
              style={{
                borderWidth: 1,
                borderColor: AppColors.gray_E4E4E4,
                padding: 10,
                borderRadius: 10,
                width: "100%",
                alignItems: "center",
              }}
            >
              <Text style={AppFontStyle.BOLD_ANYBODY_16}>My Profile</Text>
            </TouchableOpacity>
            <Separator
              color={AppColors.white}
              height={1}
              marginTop={20}
              marginBottom={20}
              marginHorizontal={0}
            />
          </View>
          <View>
            {!isAdmin && (
              <TouchableOpacity
                style={{ marginBottom: 20 }}
                onPressIn={() => {
                  setReferAndEarnPopUp(true);
                  onClose();
                }}
              >
                <Text style={AppFontStyle.BOLD_ANYBODY_14}>Refer & Earn</Text>
              </TouchableOpacity>
            )}
            <TouchableOpacity onPress={() => logout()}>
              <Text style={AppFontStyle.BOLD_ANYBODY_14}>Sign Out</Text>
            </TouchableOpacity>
          </View>
        </View>
        {<ShowLoader showIndicater={showLoader} isBackGround={true} />}
      </View>
    </Modal>
  );
};

const useStyles = CreateResponsiveStyle(
  {
    modalOverlay: {
      flex: 1,
      backgroundColor: "rgba(0, 0, 0, 0.5)",
    },
    overlayBackground: {
      position: "absolute",
      width: "100%",
      height: "100%",
    },
    modalContent: {
      backgroundColor: AppColors.purple_453B50,
      padding: 24,
      borderRadius: 12,
      elevation: 5,
      borderWidth: 1,
      borderColor: AppColors.gray_A6A3AA,
    },
  },
  {
    [DEVICE_SIZES.MD]: {},
    [DEVICE_SIZES.LG]: {},
    [DEVICE_SIZES.SM]: {},
    [DEVICE_SIZES.XS]: {},
  }
);

export default ProfilePopup;
